import type { DriverType } from '@ria-client/supergraph/marketplace/types';
import { TableCell } from '@ria-client/tw-shadcn/components/table';
import { DisclosureTooltip } from '@ria-client/tw-shared-ui';
import isEqual from 'lodash/isEqual';
import { CircleHelp } from 'lucide-react';
import { memo } from 'react';

export interface DetailsCellProps {
  drivers: DriverType[];
}

export const DetailsCell = memo(
  function DetailsCell({ drivers }: DetailsCellProps) {
    return (
      <TableCell className="align-top border-b-[var(--content-neutral-lighter-2)] border-l-0 pt-[var(--cell-padding-top)]">
        <div className="flex h-full flex-col gap-3 pt-3">
          {drivers.map(driver => (
            <div className="flex flex-col gap-1" key={driver.id}>
              <span className="typography-text-small font-bold">{driver.label}</span>
              <span className="typography-text-small">
                {driver.value ?? 'N/A'}
                {driver.valueTooltip ? (
                  <DisclosureTooltip
                    trigger={
                      <button
                        aria-label={`${driver.label} info tooltip`}
                        className="ml-1.5 inline-flex align-text-bottom text-muted-foreground"
                        type="button"
                      >
                        <CircleHelp aria-hidden size={14} />
                      </button>
                    }
                  >
                    <span className="typography-text-small">{driver.valueTooltip}</span>
                  </DisclosureTooltip>
                ) : null}
              </span>
              {driver.description ? (
                <span className="typography-text-extra-small text-muted-foreground">
                  {driver.description}
                </span>
              ) : null}
            </div>
          ))}
        </div>
      </TableCell>
    );
  },
  (previous, next) => isEqual(previous.drivers, next.drivers),
);
